export const environment = {
  production: true,

  debug: false,
  backend: 'https://app.itwiththebest.com:1102',
  backendReport: 'https://app.itwiththebest.com:1102',
  mainApp: 'https://itwiththebest.com',
  s3Region: 'eu-central-1',
  s3BucketName: 'itwiththebest-apps',
  s3Folder: '99-itwiththebest-prod',
  dateFormat: 'dd-MM-yyyy',
  info: true,
  error: true,
  log: true,
  fakeLogin: false,
  
  company: {
    name: "SC LogicLand SRL", //{{PARAM_COMPANY_NAME}}
    j: "",                    //{{PARAM_COMPANY_J}}
    cui: "",
    management: "s",
    registerLocation: "s2",
    website: "itwiththebest.com",
    address: {
      no: "",
      street: "",
      building: "",
      floor: "",
      apartament: "",
      city: "",
      county: "",
      country: ""
    },
    contactInfo: {
      person: "",
      telephone: "",
      email: "",
      contactTelephone: "+40 743 366 266",
      contactEmail: "contact@itwiththebest.com",
      privacyEmail: "privacy@itwiththebest.com",
      salesEmail: "sales@itwiththebest.com",
      dpoEmail: "dpo@itwiththebest.com",
    }
  },
};
